import { IsBoolean, IsOptional, IsString, IsUUID, IsIn } from 'class-validator';

export class CreateApprovedCarrierRequestDto {
    /**
     * Warehouse detail ID - link to warehouse
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsUUID()
    warehouseDetailId!: string;

    /**
     * Shipping direction (Inbound or Outbound)
     * @example 'OUTBOUND'
     */
    @IsOptional()
    @IsString()
    @IsIn(['INBOUND', 'OUTBOUND'])
    direction?: string;

    /**
     * Transportation provider name (e.g., DHL Global Forwarding, FedEx Custom Critical, ATS)
     * @example 'DHL Global Forwarding'
     */
    @IsOptional()
    @IsString()
    transportationProviderName?: string;

    /**
     * Is heated service required?
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    heatedServiceRequired?: boolean;

    /**
     * Are temperature data loggers used?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    tempDataLoggersUsed?: boolean;

    /**
     * Type of logger (e.g. LIBERO CB, Sensitech)
     * @example 'LIBERO CB'
     */
    @IsOptional()
    @IsString()
    loggerType?: string;

    /**
     * Notes
     * @example 'Alternate providers, US-labelled product details'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
